/**
 * dlaf.jp は DLsite のアフィリエイトリダイレクタで、廃版・不正な作品 ID を
 * 渡すと別作品ページにフォールバック転送する挙動がある。OGP プロキシは
 * 最終リダイレクト先の OGP を返すため、要求 URL とは無関係な作品の
 * タイトル/画像が表示されてしまう。要求側 ID とレスポンス側 ID の差を
 * 検出してそうしたカードを抑制するための判定ヘルパ。
 */
export function isDlafIdMismatch(
  requestUrl: string,
  responseUrl: string,
): boolean {
  let request: URL;
  let response: URL;
  try {
    request = new URL(requestUrl);
    response = new URL(responseUrl);
  } catch {
    return false;
  }
  const host = request.hostname;
  if (host !== "dlaf.jp" && !host.endsWith(".dlaf.jp")) return false;

  const reqId = request.pathname
    .match(/\/(?:id|aid)\/([A-Z]+\d+)\.html(?:\/|$)/i)?.[1]
    ?.toUpperCase();
  const resId = response.pathname
    .match(/\/product_id\/([A-Z]+\d+)\.html(?:\/|$)/i)?.[1]
    ?.toUpperCase();
  if (!reqId || !resId) return false;
  return reqId !== resId;
}
